import { QueryKey, UseQueryOptions } from "@tanstack/react-query";

import { graphql } from "lib/generated/app-service-gql";
import { OpportunityQuery } from "../../../generated/app-service-gql/graphql";
import { useGraphQlQuery } from "../useGraphQlClient";
import { REACT_QUERY_OPTIONS_NEVER_REFETCH } from "../utils";

const OPPORTUNITY_QUERY = graphql(`
  query opportunity($id: String!) {
    opportunity(id: $id) {
      id
      name
      description
      value
      assignedTo {
        guid
        firstName
        lastName
      }
      createdBy {
        guid
        firstName
        lastName
      }
      notices {
        guid
        name
        stage
        stagev2
        expiryDate
        closeDate
        publishDate
        procurementStage {
          id
        }
        lots {
          suppliers {
            guid
            name
          }
        }
        buyers {
          guid
        }
      }
      buyerActivity {
        status
        createdAt
        relatedNotices {
          guid
          name
          stage
          stagev2
          expiryDate
          closeDate
          publishDate
          value
          lots {
            suppliers {
              guid
              name
            }
          }
          buyers {
            guid
          }
          procurementStage {
            id
            stage
          }
        }
        questions {
          question
          answer
        }
      }
      documents {
        id
        title
        category
        publishedAt
        buyers {
          id
          name
        }
      }
      frameworks {
        id
        title
        stage
        tenderPeriod {
          endDate
        }
        contractPeriod {
          endDate
        }
        buyers {
          id
          name
        }
      }
      suppliers {
        name
        countryCode
        id
        logoUrl
        noticeCount
      }
      buyers {
        id
        name
        categoryAssignments {
          categoryName
          parentCategoryName
        }
        logoUrl
      }
      comments {
        id
        content
        author {
          guid
          firstName
          lastName
        }
        createdAt
        updatedAt
      }
      stage {
        id
        name
        color
        iconName
        iconColor
        transitionGroup
      }
      contacts {
        id
        title
        jobTitle
        jobFunction
        seniority
        firstName
        lastName
        email
        phone
        buyer {
          id
          name
        }
        opportunities {
          id
        }
      }
      routeToMarket
      clarificationDeadline
      submissionDate
      startDate
      existingExpiryDate
      closeDate
      createdAt
      updatedAt
      bid {
        id
      }
    }
  }
`);

export type OpportunityDetails = OpportunityQuery["opportunity"];

export function useOpportunity(
  id: string,
  options?: UseQueryOptions<OpportunityQuery, unknown, OpportunityQuery, QueryKey>,
) {
  const { data, ...rest } = useGraphQlQuery(["opportunity", id], OPPORTUNITY_QUERY, [{ id }], {
    ...options,
    ...REACT_QUERY_OPTIONS_NEVER_REFETCH,
  });
  return { data: data?.opportunity, ...rest };
}
